<template>
  <div id="app">
    <div class="survey-revealer">
      <h1>HAVE YOUR SAY</h1>
      <div class="app-wrapper">
        <VoteForm v-if="voteShow" @dismissed="componentDismisser" formId="ACT" />
        <VoteDisplay v-if="animationShow" @dismissed="componentDismisser" 
        formId="ACT" />
        <p class="vote-status" v-show="statusShow">Your vote has been received!</p>
      </div>
    </div>
    <div class="loader">
      loading...
    </div>
  </div>
</template>

<script>
import VoteForm from "./components/VoteForm.vue";
import VoteDisplay from "./components/VoteDisplay.vue";

export default {
  name: "App",
  components: {
    VoteDisplay,
    VoteForm,
  },
  data() {
    return {
      voteShow: false,
      animationShow: true,
      statusShow: false
    };
  },
  methods: {
    componentDismisser(which) {
      console.log(which);
      this.voteShow = !this.voteShow;
      this.animationShow = !this.animationShow;

      if (which == 'form') {
        this.statusShow = true
        setTimeout(() => this.statusShow = false, 3000)
      }
     },
  },
};
</script>

<style lang="scss">
#app {
  --color-white: #fff;
  --color-black: #000;
  --color-black-light: #000000cc;
  --color-black-label: #000000ee;

  max-width: 768px;
  margin: 0 auto;
  padding: 10px;
  position: relative;
  text-transform: uppercase;
  font-family: sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 60px;
  font-weight: bold;
  color: var(--color-black);
}

.fade-enter-active,
.fade-leave-active {
  position: absolute;
  top: 4em;
  left: 50%;
  width: 748px;
  transform: translateX(-50%);
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.vote-status {
  margin: 2em;
}

.survey-revealer {
  display: none;
}
</style>
